module.exports = __webpack_public_path__ + "img/106.696d4f80.png";